import { ErrorBoundary, Text } from '@dixa/lib-shared-habla';
import { RatingNotOfferedEntry } from 'lib-shared-legacy-types';

import { getEvaluationSummary } from './csatFilterEvaluationResults/utils';
import { FilterEvaluation } from './filterEvaluation';
import { LogEntry } from './logEntry';

type RatingNotOfferedProps = {
  entry: RatingNotOfferedEntry;
};

export const RatingNotOffered = ({
  entry,
}: RatingNotOfferedProps): JSX.Element => {
  const hasFilterEvaluation =
    entry.evaluation_filters &&
    entry.evaluation_filters.filterEvaluations.length > 0;

  const { secondaryText } = hasFilterEvaluation
    ? getEvaluationSummary(entry.evaluation_filters!)
    : { secondaryText: 'No filter evaluation results available' };

  const text = 'Conversation rating was not offered';

  return (
    <LogEntry
      entry={entry}
      text={text}
      secondaryText={secondaryText}
      icon="smile"
      isExpandable={hasFilterEvaluation}
    >
      {hasFilterEvaluation && entry.evaluation_filters && (
        <ErrorBoundary
          fallback={<Text.Paragraph>Something went wrong</Text.Paragraph>}
        >
          <FilterEvaluation
            filterEvaluationResults={entry.evaluation_filters}
          />
        </ErrorBoundary>
      )}
    </LogEntry>
  );
};
